import React, { useContext } from 'react'

import { BudgetContext } from './context'
import { TabHeader } from '@components/TabHeader'

export const Header = () => {
  const { state: { filter } } = useContext(BudgetContext)
  return (
    <TabHeader title={`Let's plan your budget`}>
      <TabHeader.Filter filter={filter} />
    </TabHeader>
  )
}
